import { Record } from 'immutable';
import { updateEmailActions } from './change-email.actions';
import * as api from '../../api';

export const ChangeEmailState = Record({
  updateState: api.ApiCallState({}),
});

export const changeEmailReducer = (initialState = new ChangeEmailState(), action) => {
  var state = initialState.set('updateState',
    api.apiCallReducer(initialState.get('updateState'), action, updateEmailActions));

  switch (action.type) {
    case '@@router/LOCATION_CHANGE':
      return new ChangeEmailState();
    default:
      return state
  }
}



// WEBPACK FOOTER //
// src/acct/email/change-email.reducer.js